module.exports = __webpack_public_path__ + "img/7.fee49cd4.png";